import { AfterViewInit, Component, OnInit, inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { LocalizedDatePipe } from '../../../pipes/localized-date.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { ImageLoaderDirective } from '../../../directives/image-loader.directive';

@Component({
    selector: 'app-multi-date-calendar-component',
    templateUrl: './multi-date-calendar-component.component.html',
    styleUrls: ['./multi-date-calendar-component.component.scss'],
    imports: [ImageLoaderDirective, TranslateModule, LocalizedDatePipe]
})
export class MultiDateCalendarComponentComponent implements  OnInit {
  bsModalRef = inject(BsModalRef);
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);

  evetTime : any;
  data : any
  multipleEventPopUpData : any


  ngOnInit(): void {
    this.multipleEventPopUpData= this.evetTime.multipleEvents.map(event => {
      return {
        image: this.data.image,
        location: this.data.location,
        title: this.data.title,
        startDateTime: event.startDateTime,
        eventId : event.eventId
      };
    });
  }
  
  closeModal() {
    this.bsModalRef.hide();
  }

  gotoEvent(eventId){
    this.bsModalRef.hide();
    const mvParam = this.activatedRoute.snapshot.queryParams['mv'];
    this.router.navigate([`/evento/${eventId}`], mvParam ? { queryParams: { mv: mvParam } } : {});
  }
}
